import React, { useEffect, useState } from "react";
import { Title, Container } from "./styles";
import MainTable from "../../../../components/MainTable";
import { CSidebar } from "../../../../components/Sidebar";
import Header from "../../../../components/Header";
import api from "../../../../services/api";
import { useAuth } from "../../../../hooks/auth";
import getPermission from "../../../../utils/getPermission";

const OrganizacaoRh: React.FC = () => {
  const [orgaos, setOrganizations] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const {login} = useAuth();
  const rhPermission = getPermission(login,"Recursos Humanos") ?? '';

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      api
        .get(`organizations?busca_rapida=${searchValue}`)
        .then((response) => {
          setOrganizations(response.data);
        })
        .catch((error) => console.log(error));
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [searchValue]);

  const handlePagination = (goBack = false) => {
    const page = goBack ? -1 : 1;

    api
      .get(`organizations?page=${orgaos.pagination.current_page + page}`)
      .then((response) => {
        setOrganizations(response.data);
      })
      .catch((error) => console.log(error));
  };

  const columnData = [
    { headerName: "Código", field: "id" },
    { headerName: "Organização", field: "tipo" },
    { headerName: "Nome", field: "nome" },
    { headerName: "Telefone", field: "telefone" },
    { headerName: "Email", field: "email" },
    { headerName: "Situação", field: "ativo" },
  ];

  const organizeData = (data) => {
    const withoutData = <i>Sem dados</i>;

    if (typeof data === "object") {
      data = data.map((d) => ({
        id: d.id,
        tipo: d.tipo?.toUpperCase(),
        nome: d.nome,
        telefone: d.telefone ? d.telefone : withoutData,
        email: d.email,
        ativo: d.ativo,
      }));
    }

    return data;
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ height: "100%" }}>
        <CSidebar />
      </div>
      <div style={{ display: "block", width: "100%" }}>
        <Header />
        <Title color="#333">
          <span>Gestão de organizações</span>
        </Title>
        <Container color="#FFF">
          <MainTable
            onSearchChange={setSearchValue}
            data={organizeData(orgaos.data)}
            pagination={orgaos.pagination}
            permission={rhPermission}
            hideCreate={rhPermission == "Visitante"}
            handlePagination={handlePagination}
            hideFilter={true}
            isMaxWidthCell
            registerLink="/rh/cadastros/organizacao/cadastrar"
            columns={columnData}
            dropdown={{
              view: { linkTo: "/rh/cadastros/organizacao/visualizar" },
              editar: { linkTo: "/rh/cadastros/organizacao/editar" },
              desativar: { linkTo: "organizations" },
            }}
          />
        </Container>
      </div>
    </div>
  );
};

export default OrganizacaoRh;
